<template>
    <div id="prop-reviews" class="reviews-cont" v-if="reviews.length > 0">
      <div class="content">
        <h2>
          Review{{reviews.length >= 1 ? 's' : ''}} ({{reviews.length}})
          <button class="show-more"
                  @click="toggleReviews"
                  aria-label="Show less reviews"
                  :class="{more: visibleReviews >= reviews.length}"
                  v-if="reviews.length > 2 && visibleReviews >= reviews.length">
            <b>Show less reviews</b>
            <svg class="icon up">
              <use xlink:href="#ico-arr"/>
            </svg>
          </button>
        </h2>
        <div v-for="(review, index) in showReviewsData" :key="index" class="review">
          <div class="review-header">
            <p v-if="review.author">
              <b>{{ review.author }}</b>
            </p>
            <span v-if="review.date">, {{ review.newDate }}</span>
          </div>
          <div class="review-cont" v-if="review.body">
            "{{ review.body }}"
          </div>
          <div class="review-options" v-if="track.visitorEmailId === '0' && index === 0">
            <button @click="clickBanner" aria-label="Become member">Sign in to rate reviews</button>
          </div>
          <div class="review-options" v-else-if="track.visitorEmailId !== '0' && !review.rateable">
            <p class="helpful">You have already provided feedback, thank you</p>
          </div>
          <div class="review-options" v-else-if="review.error">
            <p class="helpful">Oops! Something went wrong. Please try again later.</p>
          </div>
          <div class="review-options rateable" v-else-if="track.visitorEmailId !== '0' && review.rateable && (!submittedReviews[review.id] || (submittedReviews[review.id] && !submittedReviews[review.id].visible))">
            <p>Was this review helpful?</p>
            <button @click="() => submitUseful(review, 'helpful')"
                    :disabled="submittedReviews[review.id]"
                    :class="{bold: submittedReviews[review.id] && submittedReviews[review.id].decision === 'helpful'}">
              Yes
            </button>
            <span> / </span>
            <button @click="() => submitUseful(review, 'unhelpful')"
                    :disabled="submittedReviews[review.id]"
                    :class="{bold: submittedReviews[review.id] && submittedReviews[review.id].decision === 'unhelpful'}">
              No
            </button>
          </div>
          <div class="review-options" v-else-if="submittedReviews[review.id] && submittedReviews[review.id].visible">
            <p class="helpful">Thank you for your feedback!</p>
          </div>
          <hr v-if="showReviewsData.length - 1 !== index" class="divider">
        </div>
        <button class="show-more"
                @click="toggleReviews"
                v-if="reviews.length > 2"
                :class="{more: visibleReviews >= reviews.length}"
                :aria-label="visibleReviews === 2 ? 'Show all reviews' : 'Show less reviews'">
          <b v-if="visibleReviews < reviews.length">Show more reviews</b>
          <b v-else>Show less</b>
          <svg class="icon" :class="{down: visibleReviews < reviews.length, up: visibleReviews >= reviews.length}">
            <use xlink:href="#ico-arr"></use>
          </svg>
        </button>
      </div>
    </div>
</template>

<script>
export default {
  data: function () {
    return {
      visibleReviews: 2,
      reviewsData: this.reviews,
      submittedReviews: {}
    }
  },
  props: {
    track: Object,
    reviews: Array,
  },
  methods: {
    toggleReviews() {
      if (this.visibleReviews < this.reviews.length) {
        this.visibleReviews = this.visibleReviews + 15;
        this.$emit('sendTrack', "click-show-more-reviews", true)
      } else {
        this.visibleReviews = 2;
        let reviews = document.getElementById('prop-reviews');
        const y = reviews.getBoundingClientRect().top + window.scrollY - 20;

        window.scroll({
          top: y,
          behavior: 'smooth'
        });
      }
    },
    clickBanner() {
      this.$emit('clickBanner', null, null, 'desktop_panel')
    },
    submitUseful(review, decision) {
      const app = this;
      fetch(`/reviews/${review.id}/helpful`, {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': "application/json; charset=utf-8",
          'X-CSRF-TOKEN': st.getCSRFToken(),
        },
        body: JSON.stringify({"helpful": decision === 'helpful'})
      }).then(function(resp) {
        if (resp.status !== 200) {
          app.reviewsData = app.reviewsData.map(function(el) {
            if (el.id === review.id) {
              el.error = true;
            }
            return el;
          });
        }
      })

      const submittedReviews = {...this.submittedReviews};

      submittedReviews[review.id] = {
        decision: decision,
        visible: false
      };

      this.submittedReviews = submittedReviews;

      setTimeout(function () {
        submittedReviews[review.id] = {
          decision: decision,
          visible: true
        };
      }, 1000);

    }
  },
  computed: {
    showReviewsData() {
      return this.reviewsData.slice(0, this.visibleReviews)
    }
  },
  created() {
    let result = this.reviews.map(function(el) {
      let reviewDate = Object.assign({}, el);

      if (el.date) {
        let elementDate = new Date(el.date);
        elementDate = elementDate.toDateString().split(" ");
        reviewDate.newDate = elementDate[1] + " " + elementDate[3];
      }
      return reviewDate;
    })
    this.reviewsData = result;
  },
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.reviews-cont {
  margin: 1.25rem 0;
  padding: 0 1.25rem;

  h2 {
    display: flex;
    font-size: 1.25rem;
    margin-top: 1.25rem;
    flex-direction: row;
    line-height: 1.25rem;
    justify-content: space-between;
  }

  .content {
    padding-bottom: 1.25rem;
    border-bottom: 1px solid #D9D9D9;
  }

  .review {
    margin: 1.25rem 0;

    &-header {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      margin-bottom: .625rem;

      p, span {
        font-size: 1rem;
        line-height: 1.125rem;
        color: $col_darkgrey;
      }
    }

    &-cont {
      position: relative;
      font-size: 0.875rem;
      line-height: 1.125rem;
      margin-bottom: .875rem;
    }

    &-options {
      display: flex;
      flex-direction: row;
      align-items: baseline;

      p, span, button {
        font-size: .875rem;
        line-height: 1.125rem;
        letter-spacing: -0.38px;
      }

      p, span {
        color: #424242;
      }

      button {
        cursor: pointer;
        padding: 0 .25rem;
        color: var(--primary-color);
        background: transparent;
        text-decoration: underline;

        &.bold {
          font-weight: 700;
        }
        
        &:disabled {
          cursor: default;
        }
      }
    }

    .divider {
      border: none;
      height: 0.063rem;
      margin: 0.875rem 0;
      background-color: #D9D9D9;
    }
  }

  .show-more {
    display: flex;
    cursor: pointer;
    align-items: center;
    flex-direction: row;
    background: transparent;

    b {
      font-size: 0.875rem;
      line-height: 1.125rem;
      margin-right: .425rem;
      letter-spacing: -0.38px;
      color: var(--primary-color);
    }

    svg {
      width: 0.938rem;
      height: 0.8rem;
      fill: var(--primary-color);

      &.up {
        transform: rotate(-90deg);
      }

      &.down {
        transform: rotate(90deg);
        margin-bottom: -.15rem;
      }
    }

    &:hover {
      b {
        text-decoration: underline;
      }
    }
  }

  @media #{$desktop} {
    h2 {
      font-size: 1.5rem;
      line-height: 1.813rem;
    }

    .review {
      &-cont {
        font-size: 1rem;
        line-height: 1.25rem;
        margin-bottom: 1.25rem;
      }

      .divider {
        margin: 1.25rem 0;
      }
    }

    .show-more b {
      font-size: 1rem;
      line-height: 1.188rem;
    }

    padding: 0;
  }
}
</style>